/**
* Make Divi blog grid items the same height (Blog module/ layout = grid)
* Source: https://help.elegantthemes.com/en/articles/3371227-blog-module-equal-height-grid-boxes-with-javascript
*
* Custom class: et_blog_grid_equal_height
*/
;(function (jQuery) {
	jQuery(document).ready(function() {
		jQuery(window).resize(function() {
			jQuery('.et_blog_grid_equal_height').each(function() {
				equalise_articles(jQuery(this));
			});
		});

		jQuery('.et_blog_grid_equal_height').each(function() {
			var blog = jQuery(this);

			equalise_articles(jQuery(this));

			var observer = new MutationObserver(function(mutations) {
				equalise_articles(blog);
			});

			var config = {
				subtree: true,
				childList: true
			};

			observer.observe(blog[0], config);
		});

		function equalise_articles(blog) {
			var articles = blog.find('article');
			var heights = [];

			articles.each(function() {
				var height = 0;
				height += (jQuery(this).find('.et_pb_image_container, .et_main_video_container').length != 0) ? jQuery(this).find('.et_pb_image_container, .et_main_video_container').outerHeight(true) : 0;
				height += jQuery(this).find('.entry-title').outerHeight(true);
				height += (jQuery(this).find('.post-meta').length != 0) ? jQuery(this).find('.post-meta').outerHeight(true) : 0;
				height += (jQuery(this).find('.post-content').length != 0) ? jQuery(this).find('.post-content').outerHeight(true) : 0;

				heights.push(height);
			});

			var max_height = Math.max.apply(Math,heights);

			articles.each(function() {
				jQuery(this).height(max_height);
			});
		}

		jQuery(document).ajaxComplete(function() {
			jQuery('.et_blog_grid_equal_height').imagesLoaded().then(function() {
				jQuery('.et_blog_grid_equal_height').each(function(){
					equalise_articles(jQuery(this));
				});
			});
		});

		jQuery.fn.imagesLoaded = function() {
			var imgs = this.find('img[src!=""]');
			var dfds = [];

			if (!imgs.length) {
				return jQuery.Deferred().resolve().promise();
			}

			imgs.each(function(){
				var dfd = jQuery.Deferred();
				dfds.push(dfd);
				var img = new Image();

				img.onload = function() {
					dfd.resolve();
				};

				img.onerror = function() {
					dfd.resolve();
				};

				img.src = this.src;
			});

			return jQuery.when.apply(jQuery, dfds);
		}
	});
})(jQuery);
